// Auth context for the `when` app. Reads the Supabase session, exposes user +
// loading, and wires PostHog identify/reset to sign-in/out. Deliberately small —
// no profile fetch here (the first-run chain owns setup state).
import { createContext, useContext, useEffect, useState } from 'react';
import { supabase, auth } from '../lib/supabase';
import { identify, resetAnalytics } from '../lib/analytics';

const AuthContext = createContext({ user: null, loading: true, signOut: async () => {} });

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!supabase) { setLoading(false); return; }

    let active = true;
    auth.getSession().then((session) => {
      if (!active) return;
      setUser(session?.user ?? null);
      setLoading(false);
    });

    const { data: sub } = auth.onAuthStateChange((event, session) => {
      setUser(session?.user ?? null);
      if (event === 'SIGNED_IN') identify(session.user.id);
      if (event === 'SIGNED_OUT') resetAnalytics();
    });

    return () => { active = false; sub?.subscription?.unsubscribe(); };
  }, []);

  const signOut = async () => { await auth.signOut(); setUser(null); };

  return (
    <AuthContext.Provider value={{ user, loading, signOut }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
